import { SchedulerPro } from '@bryntum/schedulerpro';

import { scrollCollisionTargetIntoView } from '@/features/collisions/bryntum/interactions';
import { CollisionViewedEvent } from '@/features/collisions/collisionAnalytics';
import { useCollisionStore } from '@/features/collisions/collisionStore';
import { isCollisionFiltered } from '@/features/collisions/collisionUtils';
import { useScheduleAlertStore } from '@/features/scheduleAlerts/scheduleAlertStore';
import {
  getScheduleAlertsByTarget,
  getScheduleAlertsOnDate,
  isCollision,
} from '@/features/scheduleAlerts/scheduleAlertUtils';
import { NodeName } from '@/repositories/utils/cache';
import { ScheduleStore } from '@/services/store/schedule/store';
import { useSchedulePopupStore } from '@/services/store/schedulePopup/store';
import { SchedulerPopupComponent } from '@/services/store/schedulePopup/types';

export async function onClickScheduleAlert(
  scheduler: SchedulerPro,
  scheduleStore: ScheduleStore,
  mouseEvent: MouseEvent,
  scheduleAlertId: string,
): Promise<void> {
  const scheduleAlertStore = useScheduleAlertStore();
  const schedulePopupStore = useSchedulePopupStore();

  const scheduleAlert = scheduleAlertStore.scheduleAlerts.get(scheduleAlertId);
  if (!scheduleAlert) return;

  const alertsOnSameDateWithSameTarget = getScheduleAlertsByTarget(
    getScheduleAlertsOnDate(scheduleAlertStore.scheduleAlerts, scheduleAlert.date),
  );

  if (alertsOnSameDateWithSameTarget.size > 1) {
    schedulePopupStore.closePopup();
    setTimeout(() => {
      schedulePopupStore.openPopup({
        component: SchedulerPopupComponent.SCHEDULE_ALERT_JUMP_LIST,
        payload: {
          mouseEvent,
          date: scheduleAlert.date,
        },
      });
    });
    return;
  }

  if (isCollision(scheduleAlert)) {
    const collision = scheduleAlert;
    if (isCollisionFiltered(collision.id, useCollisionStore())) return;

    scrollCollisionTargetIntoView(
      scheduler,
      scheduleStore,
      collision,
      new CollisionViewedEvent({
        type: collision.toType === NodeName.MILESTONE ? 'milestone' : 'order',
        source: 'row',
      }),
    );
  }
}
